export const toSelectItems = <T extends {value: string; content: string}>(options: T[]) =>
    options.map(({content, ...option}) => ({title: content, ...option}));
